import {Form} from 'antd'
import {InputText, Select} from '@/components/Form/index.mjs'
import FormItemBizProp from '../components/FormItemBizProp.jsx'
import FormChooseDesign from '../_DESIGN/FormChooseDesign.jsx'
import Model from './ModelSs.mjs'
import meta from './metaSs.mjs'
import SelectSs from './SelectSs.jsx'
import SsType from './SsType.mjs'

export const FormItemSs = props => (
    <Form.Item
        label={meta.name}
        name="ss"
        {...props}
    >
        <SelectSs />
    </Form.Item>
)

export const FormItemSss = props => (
    <Form.Item
        label={meta.name}
        name="sss"
        {...props}
    >
        <SelectSs multiple />
    </Form.Item>
)

export const FormItemSsName = props => (
    <FormItemBizProp
        Model={Model}
        prop="ssName"
        {...props}
    >
        <InputText allowClear />
    </FormItemBizProp>
)

export const FormItemSsUserCode = props => (
    <FormItemBizProp
        Model={Model}
        prop="ssUserCode"
        {...props}
    >
        <InputText allowClear />
    </FormItemBizProp>
)

export const FormItemIsUi = props => (
    <FormItemBizProp
        Model={Model}
        prop="isUi"
        {...props}
    >
        <Select
            allowClear
            getOptionKey={e => e[0]}
            getOptionLabel={e => e[1]}
            options={SsType}
        />
    </FormItemBizProp>
)

export default function FormChooseSs(props) {
    return (
        <FormChooseDesign {...props}>
            <FormItemSsUserCode />
            <FormItemSsName />
            <FormItemIsUi />
        </FormChooseDesign>
    )
}
